<template>
  <load-form-handler
    :promise="getTabPromise"
    v-model="resource"
    placeholder
    @load-end="onLoadEnd"
    @error="onRequestError">

    <h1 class="text-center">Nos preocupamos com a saúde de nossos alunos e as informações abaixo também são importantes para nós.</h1>
    <v-divider class="my-4 divider-accent"/>

    <v-form @submit.prevent="handleUpdateTab" id="tab-form" ref="form">

      <v-card>
        <v-flex pa-4 mb-4>
          <form-health ref="form_health"/>
        </v-flex>
      </v-card>

      <v-card>
        <v-flex pa-4 mb-4>
          <form-health-insurance ref="form_health_insurance"/>
        </v-flex>
      </v-card>

      <v-card>
        <v-flex pa-4 mb-4>
          <form-medicine />
        </v-flex>
      </v-card>

      <v-card>
        <v-flex pa-4>
          <form-threatment />
        </v-flex>
      </v-card>

    </v-form>

    <alert-modal
      :visibility="declarationModalVisibility"
      title="Confirmação de dados"
      :message="declarationMessage"
      confirmAction="OK"
      cancelAction="CANCELAR"
      @confirm="onDeclarationModal"
      @cancel="closeDeclarationModal" />

  </load-form-handler>
</template>

<script>
import * as api from '@/api'
import FormHealth from './FormHealth'
import FormMedicine from './FormMedicine'
import FormThreatment from './FormThreatment'
import FormHealthInsurance from './FormHealthInsurance'
import LoadFormHandler from '@/components/LoadFormHandler'
import AlertModal from '@/components/AlertModal'
import { mapActions } from 'vuex'
import { message, formTabs, declaration, tab } from '@/mixins'

export default {
  name: 'FormChildHealth',

  data: () => ({
    resource: {},
    isFormLoading: true
  }),

  mixins: [message, formTabs, declaration, tab],

  components: {
    FormHealth,
    FormMedicine,
    FormThreatment,
    FormHealthInsurance,
    LoadFormHandler,
    AlertModal
  },

  provide () {
    const resource = {}
    Object.defineProperty(resource, 'form', {
      enumerable: true,
      get: () => this.resource
    })
    return { resource }
  },

  methods: {
    ...mapActions({
      showSnack: 'snackbar/showSnack'
    }),

    getTabPromise () {
      return api.forms.healthInformation.get(this.currentStudentId)
    },

    handleUpdateTab () {
      if (this.$refs.form.validate()) {
        this.openDeclarationModal()
      } else {
        this.showMessageByType(this.messageTypes.VALIDATION_ERROR)
      }
    },

    onDeclarationModal () {
      api.forms.healthInformation.update(this.currentStudentId, this.resource)
        .then(response => {
          this.resource = response.data
          this.showMessageByType(this.messageTypes.MODIFIED)
        }).catch(this.handleErrorMessage)
        .finally(this.closeDeclarationModal)
    }
  }
}
</script>
